import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
import { AuthService } from "../../auth/auth.service";
import { HttpUtils } from "../../../common/http/http-utils";
import { HttpClient } from '@angular/common/http';


@Component({
    selector: 'not-found',
    template: `
        <div class="unauthorized-div">
            <clr-icon shape="error-standard" size="48" class="is-error"></clr-icon>
            <h3 service-header>{{ 'unauthorizedMessage' | translate }}</h3>
        </div>`
})

export default class ServiceUnAuthorized {

    constructor(public http: HttpClient, public translate: TranslateService, public authService: AuthService) {
        translate.use(GlobalVariables.LOCALE);
        //Do logout.
        this.authService.setAuthChangeEvent('LOGOUT_TRIGGERED');
        this.http.delete(HttpUtils.getBaseUrl() + '/hybridity/api/session');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/service-unauthorized/service-unauthorized.component.ts